/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigUnauthorizedResponse,
  SettlementOptionsResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get settlement options for branch type
 */
export const getSettlementOptions = (branchType: 'DMB' | 'IND' | 'SP', signal?: AbortSignal) => {
  return customInstance<SettlementOptionsResponseResponse>({
    url: `/BboBranchConfigService/v1/settlement-options/${branchType}`,
    method: 'get',
    signal,
  });
};

export const getGetSettlementOptionsQueryKey = (branchType: 'DMB' | 'IND' | 'SP') => {
  return [`/BboBranchConfigService/v1/settlement-options/${branchType}`] as const;
};

export const getGetSettlementOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettlementOptions>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  branchType: 'DMB' | 'IND' | 'SP',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettlementOptions>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSettlementOptionsQueryKey(branchType);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettlementOptions>>> = ({ signal }) =>
    getSettlementOptions(branchType, signal);

  return { queryKey, queryFn, enabled: !!branchType, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettlementOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSettlementOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettlementOptions>>
>;
export type GetSettlementOptionsQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Get settlement options for branch type
 */
export const useGetSettlementOptions = <
  TData = Awaited<ReturnType<typeof getSettlementOptions>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  branchType: 'DMB' | 'IND' | 'SP',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettlementOptions>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSettlementOptionsQueryOptions(branchType, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
